module.exports = __webpack_public_path__ + "img/logo-name.305fba59.png";